import React, { useState, Suspense } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Image as AtomicImage } from '@thd-olt-component-react/image';
import './EtchVisualNav.scss';

const Overlay = React.lazy(() => import(/* webpackChunkName: "overlay" */ '@thd-olt-component-react/overlay')
  .then((module) => ({ default: module.Overlay })));
const VideoPlayer = React.lazy(() => import(/* webpackChunkName: "video-player" */ '@thd-olt-component-react/video-player')
  .then((module) => ({ default: module.VideoPlayer })));

const EtchVisualNav = (props) => {
  const { opts = {} } = props;
  const [overlay, setOverlay] = useState(false);
  const [videoId, setVideoId] = useState('');
  const {
    id,
    links = [],
    type
  } = opts;

  const onBtnClick = (event) => {
    const videoId = event.target.getAttribute("data-video");
    if (videoId) {
      event.preventDefault();
      setVideoId(videoId)
      setOverlay(true);
    }
  };

  return (
    <div className="EtchVisualNav" id={id} type={type}>
      <nav className="visualNav__container-sm">
        { links.map(({ image = {}, link, linkText, id: linkId }) => {
          const videoId = (link && link.indexOf('playVideo') > -1) ? link?.match(/(\d+)/gm)?.[0] : '';
          const { src, alt, height, width } = image;
          const imgClass = classNames({
            'img--block':height && width
          });
          return (<div className="visualNav" link-id={id} key={linkId}>
            {link
            && (
              <>
                <a href={(link && link.indexOf('playVideo') === -1) ? link : '#'} onClick={onBtnClick}>
                  <AtomicImage
                    src={src}
                    className={`visualNav__img ${imgClass}`}
                    alt={alt}
                    lazy
                    data-video={videoId}
                    height={height}
                    width={width}
                  />
                </a>
                <a
                  href={(link && link.indexOf('playVideo') === -1) ? link : '#'}
                  className="visualNav__title-center"
                  data-video={videoId}
                  onClick={onBtnClick}
                >{linkText}</a>
              </>
            )}
            {!link
            && (
              <>
                <AtomicImage
                  src={src}
                  className={`visualNav__img ${imgClass}`}
                  alt={alt}
                  lazy
                  data-video={videoId}
                  height={height}
                  width={width}
                />
                <p className="visualNav__title-center">{linkText}</p>
              </>
            )}
          </div>)
        })}
      </nav>
      {overlay && (
        <Suspense fallback={<div />}>
          <Overlay onClose={() => {setOverlay(false); setVideoId('')}}  open fit closeButton modalClass="etch-widgets__video-overlay__modal">
            <div className="etch-widgets__video-overlay" data-testid="visualNav-video-overlay">
              <VideoPlayer videoId={videoId} borderColor="black" autoPlay className="etch-widgets__video-overlay__player" />
            </div>
          </Overlay>
        </Suspense>
      )}
    </div>
  );
};

EtchVisualNav.propTypes = {
  opts: PropTypes.shape({
    id: PropTypes.string,
    ctaLink: PropTypes.string,
    heroMedia: PropTypes.object,
    heroMediaMobile: PropTypes.object,
    eventLogo: PropTypes.object,
    eventLogoMobile: PropTypes.object,
    heading: PropTypes.string,
    subHeading: PropTypes.string,
    cta: PropTypes.string,
    collectionLink: PropTypes.string,
    cornerCaption: PropTypes.string,
    type: PropTypes.string
  }).isRequired
};
EtchVisualNav.defaultProps = {
};

export default EtchVisualNav;
